(function(){
  function ready(fn){if(document.readyState!=='loading'){fn();}else{document.addEventListener('DOMContentLoaded',fn);}}
  ready(function(){
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.14});
      document.querySelectorAll('.bl3d .reveal,.bl3d .band .mask').forEach(function(el,i){el.style.transitionDelay=(Math.min(i,4)*70)+'ms';io.observe(el);});
    }else{
      document.querySelectorAll('.bl3d .reveal,.bl3d .band .mask').forEach(function(el){el.classList.add('in');});
    }
    var band=document.querySelector('.bl3d .band'),bg=band&&band.querySelector('.bg');
    if(bg){window.addEventListener('scroll',function(){var r=band.getBoundingClientRect();bg.style.transform='translateY('+((r.top+r.height/2-window.innerHeight/2)*-0.06)+'px)';},{passive:true});}

    var toggle=document.querySelector('[data-navtoggle]'),drawer=document.querySelector('[data-mobilenav]');
    if(toggle&&drawer){
      function setNav(open){
        toggle.setAttribute('aria-expanded',open?'true':'false');
        toggle.setAttribute('aria-label',open?'Close menu':'Open menu');
        if(open){drawer.hidden=false;requestAnimationFrame(function(){drawer.classList.add('open');});}
        else{drawer.classList.remove('open');drawer.hidden=true;}
      }
      toggle.addEventListener('click',function(){setNav(toggle.getAttribute('aria-expanded')!=='true');});
      drawer.addEventListener('click',function(e){if(e.target.closest('a')){setNav(false);}});
      document.addEventListener('keydown',function(e){if(e.key==='Escape'&&toggle.getAttribute('aria-expanded')==='true'){setNav(false);toggle.focus();}});
      window.addEventListener('resize',function(){if(window.innerWidth>880&&toggle.getAttribute('aria-expanded')==='true'){setNav(false);}});
    }
  });
})();
